import React from "react";
import { useState, useEffect } from "react";

const Top = props => {

  const [visible, setVisible] = useState(false)
  const [translate, setTranslate] = useState(1)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
    });
  };

  const showMore = () =>{
    if(props.value === "2")
      props.onPageBack();
    else
      props.onPageTransition();
  };
  
  window.addEventListener('scroll', toggleVisible);

  useEffect(()=>{
    window.addEventListener('scroll', function() {

      if(props.value === "2") {
        if (window.scrollY<50) {
          setTranslate(4);
        } else {
          if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight)
            setTranslate(1);
          else
            setTranslate(1);
        }
      } else {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
          //setTranslate(1);
          //setTimeout(()=>{
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
              if(translate!==2)
                setTranslate(2);
              setTimeout(()=>{
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                  if(translate!==3)
                    setTranslate(3);
                }
                else
                  setTranslate(1);
              },2000);
            }
            else
              setTranslate(1);
          //},8000);
        }
        else
          setTranslate(1);
      }
    });
  })
  

  return (
    <div className="backto-top">
      <div
        className={'down'+translate}
        onClick={translate>1?showMore:scrollToTop}
        style={{
          position: "fixed",
          bottom: "50px",
          right: "30px",
          cursor: "pointer",
          transition: "opacity 0.2s linear 0s, visibility",
          opacity: "1",
          visibility: visible?"visible":"hidden",
        }}
      >
        <svg
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          viewBox="0 0 24 24"
          strokeLinecap="round"
          strokeLinejoin="round"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      </div>
    </div>
  );
};

export default Top;
